// extracted by mini-css-extract-plugin
export default {"seo-data":"_2Pnj2","seoData":"_2Pnj2"};